export default class WhatsApp {
  cep?: string;
  createdAt?: string;
  email?: string;
  id?: number;
  name?: string;
  phone?: string;
}
